export const UNIT_STATUSES = [
  "available",
  "used",
  "damaged",
  "not_working",
  "missing",
  "returned",
  "sold",
] as const

export type UnitStatus = (typeof UNIT_STATUSES)[number]

const LABELS: Record<UnitStatus, string> = {
  available: "Available",
  used: "Used",
  damaged: "Damaged",
  not_working: "Not working",
  missing: "Missing",
  returned: "Returned",
  sold: "Sold",
}

export function statusLabel(status: UnitStatus): string {
  return LABELS[status]
}

export function isUnitStatus(value: string): value is UnitStatus {
  return (UNIT_STATUSES as readonly string[]).includes(value)
}

/** Map status → Badge variant className token for UI */
export function statusBadgeVariant(
  status: UnitStatus,
): "default" | "secondary" | "destructive" | "outline" {
  switch (status) {
    case "available":
      return "default"
    case "sold":
      return "secondary"
    case "damaged":
    case "not_working":
    case "missing":
      return "destructive"
    default:
      return "outline"
  }
}
